<script>
import Selector from '../../../vue/Selector.vue';

export default {
    extends: Selector,

    components: {
        Selector,
    },

    props: {
        countriesJson: String,
    },

    data() {
        let countries = JSON.parse(this.countriesJson);

        return {
            countries: countries,
            options: [],
            selectedCountry: null,
            selectPlaceholder: this.trans('common.choose_country_shorter'),
        };
    },

    mounted() {
        window.landingSelectCountry = this;

        this.filterOptions();
    },

    watch: {
        opened(opened) {
            if (opened) {
                window.landingSelectCity.opened = false;
            }
        },
        selectedCountry(country) {
            // Update cities list.
            window.landingSelectCity.filterOptions(country.id);
        },
        selectorInput(value) {
            this.filterOptions(value);
        },
    },

    methods: {
        optionLabel(country) {
            return country.id
                ? this.trans('countries.' + country.slug_international)
                : '';
        },

        filterOptions(string) {
            string = string && string.trim();

            if (!string) {
                this.options = this.countries;
            } else {
                string = this.app.string.slugify(string);

                this.options = this.countries.filter((country) => {
                    // Ignore special chars.
                    let label = this.app.string.slugify(
                        this.optionLabel(country)
                    );

                    return !country.id || label.indexOf(string) !== -1;
                });
            }
        },

        select(country) {
            this.selectedCountry = country;
            this.selectorInput = this.optionLabel(country);

            Selector.methods.select.call(this, country);
        },
    },
};
</script>
